const loadExternalScript = (scriptUrl: string): void => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptUrl;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export default loadExternalScript;
